import { useCallback } from 'react';
import { dealerProvider } from '../../services/api';

export const useProfiles = () => {
  const getProfiles = useCallback(async () => {
    const response = await dealerProvider.get(
      'api/Perfil/listarPerfisFuncionariosRevendas',
    );
    return response.data.data;
  }, []);

  return {
    getProfiles,
  };
};

interface DealersListParams {
  search?: string;
  text?: string;
  page?: number;
  pagesize?: number;
  tipoPerfil?: string;
}

export const useDealersList = () => {
  const getDealersList = useCallback(async (params?: DealersListParams) => {
    const response = await dealerProvider.get(
      '/api/listar-funcionarios-revenda',
      {
        params,
      },
    );

    return response.data.data;
  }, []);

  return {
    getDealersList,
  };
};

export const updateDealer = async (isEdit: boolean, payload: any) => {
  if (isEdit) {
    const response = await dealerProvider.put(
      '/api/editar-usuario-revenda',
      payload,
    );
    return response.data;
  }

  const response = await dealerProvider.post(
    '/api/cadastrar-usuario-revenda',
    payload,
  );

  return response.data;
};
